import {useState} from "react";
import {ReactComponent as Removeicon} from '../../../../../assets/icons/remove.svg'; // Import your SVG icon
import "../../../../../css/CashflowModeller2/Buttons/RemoveIcon.css"; // Import your CSS file

/**
 * RemoveIcon component renders a clickable icon that toggles its "clicked" state on click.
 * Optionally executes a provided onClick handler when clicked.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {Function} [props.onClick] - Optional callback function to execute when the icon is clicked.
 * @returns {JSX.Element} The rendered RemoveIcon component.
 */
const RemoveIcon = ({ onClick }) => {
  const [clicked, setClicked] = useState(false);

  // const handleClick = () => {
  //   navigate(link); // Navigate to the provided link
  // };

  return (
    <div
      className={`removeicon ${clicked ? "clicked" : ""}`}
      onClick={() => {
        setClicked(!clicked); // Toggle the clicked state
        // handleClick();
        onClick && onClick();
      }}
    >
      <Removeicon/>
    </div>
  );
};

export default RemoveIcon;
